import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

// Fetch Exercises with Pagination
export const fetchExercisesApi = async ({
  coachId,
  pageNumber = 1,
  pageSize = 10,
}) => {
  const params = {
    PageNumber: pageNumber,
    PageSize: pageSize,
  };
  const response = await axiosInstance.get(
    `${Endpoints.GET_ALL_EXERCISES}/${coachId}`,
    { params }
  );
  return response.data;
};

// Filter Exercises by Name
export const filterExercisesApi = async ({
  coachId,
  name = "",
  equipment,
  muscleGroup,
  isCustomized,
}) => {
  const params = {
    name: name,
    equipment: equipment?.join(",") || "",
    muscleGroup: muscleGroup?.join(",") || "",
    isCustomized: isCustomized,
  };

  const response = await axiosInstance.get(
    `${Endpoints.FILTER_EXERCISES}/${coachId}`,
    { params }
  );

  return {
    exerciseList: response.data.exerciseList,
    totalCount: response.data.totalCount,
  };
};

export const upsertExerciseApi = async (coachId, exerciseData) => {
  const response = await axiosInstance.post(
    `${Endpoints.UPSERT_EXERCISE}/${coachId}`,
    exerciseData
  );
  return response.data;
};

// Update Exercise Favorite Status (PATCH)
export const updateExerciseFavoriteApi = async (exerciseId, isFavourite) => {
  const response = await axiosInstance.patch(
    `${Endpoints.UPDATE_EXERCISE_STATUS}/${exerciseId}/${isFavourite}`
  );
  return response.data;
};

export const fetchBodyPartsApi = async () => {
  const response = await axiosInstance.get(Endpoints.GET_BODY_PARTS);
  return response.data;
};

// Fetch Equipment
export const fetchEquipmentApi = async ({ muscleId }) => {
  const query = muscleId !== undefined ? `?muscleIds=${muscleId}` : "";

  const response = await axiosInstance.get(
    `${Endpoints.GET_EQUIPMENT}${query}`
  );
  return response.data;
};

// Fetch Muscle Groups
export const fetchMuscleGroupsApi = async ({ equipmentId }) => {
  const query = equipmentId ? `?equipmentIds=${equipmentId}` : "";

  const response = await axiosInstance.get(
    `${Endpoints.GET_MUSCLE_GROUPS}${query}`
  );
  return response.data;
};

// Sass token
export const fetchSassTokenApi = async ({ fileName, isMessenger }) => {
  const params = {
    fileName,
  };
  if (isMessenger) {
    params.isMessenger = true;
  }
  const response = await axiosInstance.get(
    `${Endpoints.EXERCISE_GET_SASS_TOKEN}`,
    { params }
  );
  return response.data;
};
